/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} When_Did_This_Happen_OptionalInputs */

const en_when_did_this_happen_optional = /** @type {(inputs: When_Did_This_Happen_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When did this happen? (Optional)`)
};

const es_when_did_this_happen_optional = /** @type {(inputs: When_Did_This_Happen_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuándo ocurrió esto? (Opcional)`)
};

const fr_when_did_this_happen_optional = /** @type {(inputs: When_Did_This_Happen_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quand cela s'est-il passé ? (Facultatif)`)
};

const de_when_did_this_happen_optional = /** @type {(inputs: When_Did_This_Happen_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wann ist das passiert? (Optional)`)
};

const ja_when_did_this_happen_optional = /** @type {(inputs: When_Did_This_Happen_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`これはいつ起きましたか？ (任意)`)
};

const zh_when_did_this_happen_optional = /** @type {(inputs: When_Did_This_Happen_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这发生什么时候？(可选)`)
};

const ar_when_did_this_happen_optional = /** @type {(inputs: When_Did_This_Happen_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`متى حدث هذا؟ (اختياري)`)
};

const id_when_did_this_happen_optional = /** @type {(inputs: When_Did_This_Happen_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapan ini terjadi? (Opsional)`)
};

const it_when_did_this_happen_optional = /** @type {(inputs: When_Did_This_Happen_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando è successo? (Opzionale)`)
};

const ru_when_did_this_happen_optional = /** @type {(inputs: When_Did_This_Happen_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Когда это произошло? (Необязательно)`)
};

const pt_when_did_this_happen_optional = /** @type {(inputs: When_Did_This_Happen_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando é que isto aconteceu? (Opcional)`)
};

const ko_when_did_this_happen_optional = /** @type {(inputs: When_Did_This_Happen_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`언제 일어난 일인가요? (선택 사항)`)
};

/**
* | output |
* | --- |
* | "When did this happen? (Optional)" |
*
* @param {When_Did_This_Happen_OptionalInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const when_did_this_happen_optional = /** @type {((inputs?: When_Did_This_Happen_OptionalInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<When_Did_This_Happen_OptionalInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_when_did_this_happen_optional(inputs)
	if (locale === "es") return es_when_did_this_happen_optional(inputs)
	if (locale === "fr") return fr_when_did_this_happen_optional(inputs)
	if (locale === "de") return de_when_did_this_happen_optional(inputs)
	if (locale === "ja") return ja_when_did_this_happen_optional(inputs)
	if (locale === "zh") return zh_when_did_this_happen_optional(inputs)
	if (locale === "ar") return ar_when_did_this_happen_optional(inputs)
	if (locale === "id") return id_when_did_this_happen_optional(inputs)
	if (locale === "it") return it_when_did_this_happen_optional(inputs)
	if (locale === "ru") return ru_when_did_this_happen_optional(inputs)
	if (locale === "pt") return pt_when_did_this_happen_optional(inputs)
	return ko_when_did_this_happen_optional(inputs)
});